   /*==========================================================================================================
  FILTERS
  ==========================================================================================================*/
   angular
    .module('vppApp')
    
    .filter('splitCaps', function() {
      return function (input) {
          return input.replace( /([a-z])([A-Z])/, "$1 $2").toLowerCase();
              
      }
  });